import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsDoesNotRequirePlanningYet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsDoesNotRequirePlanningYet: "/api/v1/portal/jobs/mark-as/toggle/does-not-require-planning-yet/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  toggleMarkJobAsDoesNotRequirePlanningYet() {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsDoesNotRequirePlanningYet+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }
  render() {
    return(
      <span> {(this.state.data.does_not_require_planning_yet === 0) ?
        <p>Job needs planning<br />
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-grey"
            title={"Toggle Mark Job as: JOBS THAT ARE DATED "+
            "IN THE FUTURE AND DON'T REQUIRE PLANNING YET"}
            onClick={(e) => this.toggleMarkJobAsDoesNotRequirePlanningYet(e)}
          >
            Mark Job As Does Not Require Planning Yet
          </button>
        </p>
        :
        <p>
          <button
            className="btn btn-lg btn-secondary"
          >
            Job does not require planning yet.
          </button>&nbsp;
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-grey"
            title={"Toggle Mark Job as: JOBS THAT ARE DATED "+
            "IN THE FUTURE AND DON'T REQUIRE PLANNING YET"}
            onClick={(e) => this.toggleMarkJobAsDoesNotRequirePlanningYet(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job As Does Not Require Planning Yet
          </button>
        </p>
      }
    </span>
    )
  }
}